import { createAction } from 'typesafe-actions';

import { SourceCard } from '../constants';

interface SourceCardOptionClickedParams extends $TSFixMe {}

export const sourceCardOptionClicked = createAction(
  SourceCard.ActionTypes.SOURCE_CARD_OPTION_CLICKED,
  (params: SourceCardOptionClickedParams) => params,
)<SourceCardOptionClickedParams>();
export type SourceCardOptionClickedAction = ReturnType<typeof sourceCardOptionClicked>;

interface SourceCardOpenedParams extends $TSFixMe {}

export const sourceCardOpened = createAction(
  SourceCard.ActionTypes.SOURCE_CARD_OPENED,
  (params: SourceCardOpenedParams) => params,
)<SourceCardOpenedParams>();
export type SourceCardOpenedAction = ReturnType<typeof sourceCardOpened>;
